// components/ZarinpalCallback.jsx
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import BASE_URL from "../../config/config";

const ZarinpalCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('در حال بررسی پرداخت...');
  const [refId, setRefId] = useState(null);
  const [csrfToken, setCsrfToken] = useState("");
  // ✅ جلوگیری از درخواست تکراری
  const hasVerified = useRef(false);

    useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await fetch(`${BASE_URL}/csrf-token`, {
          credentials: "include",
        });
        const data = await response.json();
        console.log("✅ CSRF Token دریافت شد:", data.csrfToken);
        setCsrfToken(data.csrfToken);
      } catch (error) {
        console.error("❌ خطا در دریافت CSRF Token:", error);
        setStatus('failed');
        setMessage("مشکل در دریافت توکن CSRF");
      }
    };

    fetchCsrfToken();
  }, []);

  // ✅ مرحله ۲: وقتی CSRF Token آماد شد، Verify کن
  useEffect(() => {
    // فقط اگر:
    // 1. CSRF Token دریافت شده باشه
    // 2. هنوز verify نشده باشه
    if (csrfToken && !hasVerified.current) {
      hasVerified.current = true;
      console.log("🚀 شروع verify با CSRF Token:", csrfToken);
      verifyPayment();
    }
  }, [csrfToken]);
  
  // components/ZarinpalCallback.jsx

const verifyPayment = async () => {
  const authority = searchParams.get('Authority');
  const paymentStatus = searchParams.get('Status');

  console.log("🔍 Callback params:", { authority, paymentStatus });

  if (paymentStatus !== 'OK') {
    setStatus('failed');
    setMessage('پرداخت توسط کاربر لغو شد');
    setTimeout(() => navigate('/dashboard/courses'), 3000);
    return;
  }

  if (!authority) {
    setStatus('failed');
    setMessage('Authority یافت نشد');
    setTimeout(() => navigate('/dashboard/courses'), 3000);
    return;
  }

  try {
    const token = localStorage.getItem('token');
    
    console.log("📤 ارسال درخواست verify...");  
   

    console.log("📤 ارسال درخواست verify با fetch...");

    const response = await fetch(`${BASE_URL}/zarinpal/verify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "CSRF-Token": csrfToken,           // اگر لازم است
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      credentials: "include", // اگر kuki نیاز داری
      body: JSON.stringify({
        Authority: authority,
        Status: paymentStatus,
      }),
    });

    const data = await response.json();
    console.log("📥 پاسخ verify:", data);    

    if (data.success) {
      setStatus('success');
      setMessage(data.already_verified 
        ? 'این تراکنش قبلاً تأیید شده بود' 
        : 'پرداخت با موفقیت انجام شد!'
      );
      setRefId(data.ref_id);
      
      setTimeout(() => navigate('/dashboard/courses'), 3000);
    } else {
      setStatus('failed');
      setMessage(data.message || 'تأیید پرداخت ناموفق بود');
      setTimeout(() => navigate('/dashboard/courses'), 3000);
    }
  } catch (error) {
    console.error('❌ خطا در verify:', error);
    console.error('Response:', error.response?.data);
    
    setStatus('failed');
    
    // خطای 429 (تلاش زیاد)
    if (error.response?.status === 429) {
      setMessage('تلاش‌های زیاد برای تأیید. لطفاً چند دقیقه صبر کنید');
    } 
    // خطای 404 (Authority پیدا نشد)
    else if (error.response?.status === 404) {
      setMessage('سفارش یافت نشد. لطفاً با پشتیبانی تماس بگیرید');
    }
    // سایر خطاها
    else {
      setMessage(
        error.response?.data?.message || 
        'خطا در تأیید پرداخت. لطفاً با پشتیبانی تماس بگیرید'
      );
    }
    
    setTimeout(() => navigate('/dashboard/courses'), 5000);
  }
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        {status === 'processing' && (
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500 mx-auto mb-4"></div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              در حال بررسی پرداخت
            </h2>
            <p className="text-gray-600">{message}</p>
            <p className="text-sm text-gray-400 mt-2">
              لطفاً این صفحه را رفرش نکنید
            </p>
          </div>
        )}

        {status === 'success' && (
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
              <svg
                className="h-8 w-8 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-green-600 mb-2">
              پرداخت موفق
            </h2>
            <p className="text-gray-600 mb-4">{message}</p>
            {refId && (
              <div className="bg-gray-50 rounded-lg p-4 mb-4">
                <p className="text-sm text-gray-500">کد پیگیری:</p>
                <p className="text-lg font-mono font-semibold text-gray-800">
                  {refId}
                </p>
              </div>
            )}
            <p className="text-sm text-gray-500">
              در حال انتقال به دوره‌های من...
            </p>
          </div>
        )}

        {status === 'failed' && (
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
              <svg
                className="h-8 w-8 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-red-600 mb-2">
              پرداخت ناموفق
            </h2>
            <p className="text-gray-600 mb-4">{message}</p>
            <p className="text-sm text-gray-500">
              در حال بازگشت به صفحه دوره‌ها...
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ZarinpalCallback;
